import { render, staticRenderFns } from "./reg-admin-RegV3.vue?vue&type=template&id=5c005cc3"
import script from "./reg-admin-RegV3.vue?vue&type=script&lang=js"
export * from "./reg-admin-RegV3.vue?vue&type=script&lang=js"
import style0 from "./reg-admin-RegV3.vue?vue&type=style&index=0&id=5c005cc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports